export default __webpack_public_path__ + "static/media/zukunf_lauft_background_xl1.d6d2f2d7.jpg";